<template>
  <div class="ghost-button-styles">
    <el-radio-group class="radio-group" v-model="routeName" @change="handleRouteChange">
      <el-radio-button ghost label="clipEditor">创意混剪</el-radio-button>
      <el-radio-button ghost label="creativeEditor">A-B混剪</el-radio-button>
    </el-radio-group>
  </div>
</template>

<script setup>
import { ref, onActivated } from 'vue'
import { useRouter, useRoute } from 'vue-router/composables'
const route = useRoute()
const router = useRouter()
const routeName = ref(route.name)
onActivated(() => {
  routeName.value = route.name
})
function handleRouteChange(name) {
  router.push({ name: name })
}
</script>

<style scoped lang="scss">
::v-deep .radio-group {
  width: 100%;
  .el-radio-button {
    width: 50%;
    .el-radio-button__inner {
      width: 100%;
    }
  }
}
</style>
